'use strict';

// Used to match keys in toggle-logic with feature flag checks in the code

module.exports = {
  displayWeightToggle: 'displayWeightToggle',
  displayHierarchyAndFilter: 'displayHierarchyAndFilter',
  displayCompetitorDownload: 'displayCompetitorDownload',
  displayCompetitorUpload: 'displayCompetitorUpload',
  displayCompetitorActionsMenu: 'displayCompetitorActionsMenu',
  displayAddCompetitorButton: 'displayAddCompetitorButton',
  displayCompetitorHistoricalPrices: 'displayCompetitorHistoricalPrices',
  displayCompetitorPromotion: 'displayCompetitorPromotion',
  workpackageExportFunction: 'workpackageExportFunction',
  includeNormWeight: 'includeNormWeight',
  displayRulesListView: 'displayRulesListView',
  competitorIndexWeightings: 'competitorIndexWeightings',
  useZones: 'useZones',
  useStoreGroupChains: 'useStoreGroupChains',
  competitorIndexWeightingTypes: {
    sales: 'sales',
    volume: 'volume',
    price: 'price',
  },
  numberWeeksHistoryLookForward: 'numberWeeksHistoryLookForward',
  displayStoreGroupPenalty: 'displayStoreGroupPenalty',
  displayMinMaxPenalty: 'displayMinMaxPenalty',
  displayStoreGroupCompetitors: 'displayStoreGroupCompetitors',
  beforePromotionDays: 'beforePromotionDays',
  displayExportToSAPButton: 'displayExportToSAPButton',
  displayExportPenaltyDataButton: 'displayExportPenaltyDataButton',
  displayExportToAPIButton: 'displayExportToAPIButton',
  showGoLiveDateDialog: 'showGoLiveDateDialog',
  displayHistoricalDropdown: 'displayHistoricalDropdown',
  displayCompetitorHistoryGaps: 'displayCompetitorHistoryGaps',
  unsetUMApprovalOnPriceChange: 'unsetUMApprovalOnPriceChange',
  exportWorkpackageOnUMApproval: 'exportWorkpackageOnUMApproval',
  useReleaseCheckboxApprovals: 'useReleaseCheckboxApprovals',
  extraDecimalPlacesForMarginDelta: 'extraDecimalPlacesForMarginDelta',
  getGroupedAggregations: 'getGroupedAggregations',
  getSingleAggregations: 'getSingleAggregations',
  enableGlobalRuleEdit: 'enableGlobalRuleEdit',
  allowTemplateIntentionCostChange: 'allowTemplateIntentionCostChange',
  allowTemplateFeedCompetitorUpload: 'allowTemplateFeedCompetitorUpload',
  allowNegativeTargetMargin: 'allowNegativeTargetMargin',
  allowGreaterThan100PercentTargetMargin: 'allowGreaterThan100PercentTargetMargin',
  displayWholesaleTab: 'displayWholesaleTab',
  displayArchitectureSubGroupSplittingAttributes: 'displayArchitectureSubGroupSplittingAttributes',
  enableAnchorMarginsModule: 'enableAnchorMarginsModule',
  anchorMarginsHierarchyAggLevel: 'anchorMarginsHierarchyAggLevel',
  anchorMarginsEnableDeltas: 'anchorMarginsEnableDeltas',
  enableCDTHierarchies: 'enableCDTHierarchies',
  cascadeAttributes: 'cascadeAttributes',
  exportPriceChanges: 'exportPriceChanges',
  allowWholesaleExport: 'allowWholesaleExport',
  useFirstFuturePrice: 'useFirstFuturePrice',
  enableExportWholesaleForceClose: 'enableExportWholesaleForceClose',
  displayWholesaleExportAll: 'displayWholesaleExportAll',
  displayWholesaleImportGrids: 'displayWholesaleImportGrids',
  displayGridsStoregroupsUpdate: 'displayGridsStoregroupsUpdate',
  useDefaultFilter: 'useDefaultFilter',
  defaultCategoryFilter: 'defaultCategoryFilter',
  useStickersPromotion: 'useStickersPromotion',
  useIndependentAttributeFilters: 'useIndependentAttributeFilters',
  recalculateAllOnWorkpackageCreation: 'recalculateAllOnWorkpackageCreation',
  allowedHierarchyLevelsForRecalculate: 'allowedHierarchyLevelsForRecalculate',
  runProductExistWithUnassignedPGAttribute: 'runProductExistWithUnassignedPGAttribute',
  addProductGoLiveDateAttribute: 'addProductGoLiveDateAttribute',
  selectCompetitorsOnExport: 'selectCompetitorsOnExport',
  // same as use_manual_product_go_live_date
  useManualProductGoLiveDate: 'useManualProductGoLiveDate',
  canAccessDevAdminTabs: 'canAccessDevAdminTabs',
  navbarColorHighlightAll: 'navbarColorHighlightAll',
  navbarColorHighlightOw: 'navbarColorHighlightOw',
  owUsersCanExport: 'owUsersCanExport',
  groupBySubGroupsAndArchitecture: 'groupBySubGroupsAndArchitecture',
  showCookieBanner: 'showCookieBanner',
  saveResultsToDatabricks: 'saveResultsToDatabricks',
  saveResultsToMongo: 'saveResultsToMongo',
  useAgGridProductList: 'useAgGridProductList',
  defaultCompetitorsDisplayCount: 'defaultCompetitorsDisplayCount',
  maxCompetitorsDisplayCount: 'maxCompetitorsDisplayCount',
  maxPricePointingTokens: 'maxPricePointingTokens',
  competitorsToSelectOnExport: 'competitorsToSelectOnExport',
  displayFixedCompetitorPenaltyWeight: 'displayFixedCompetitorPenaltyWeight',
  fixedCompetitorPenaltyWeightOptions: 'fixedCompetitorPenaltyWeightOptions',
  displayMaxUpDown: 'displayMaxUpDown',
  defaultGridViewAttributes: 'defaultGridViewAttributes',
  excludedGridViewAttributes: 'excludedGridViewAttributes',
  maxAdditionalGridViewAttributes: 'maxAdditionalGridViewAttributes',
  gridViewAgGridMandatoryFields: 'gridViewAgGridMandatoryFields',
  workpackageCreationHierarchyLevel: 'workpackageCreationHierarchyLevel',
  enableAOExtracts: 'enableAOExtracts',
  usePeriodIdsInAOExtracts: 'usePeriodIdsInAOExtracts',
  enableCalculatedCompletionDate: 'enableCalculatedCompletionDate',
  calculatedCompletionDateDaysBeforeGoLive: 'calculatedCompletionDateDaysBeforeGoLive',
  hideRedundantHierarchyLevels: 'hideRedundantHierarchyLevels',
  useForecastVolume: 'useForecastVolume',
  useMatchingPriceInAggregation: 'useMatchingPriceInAggregation',
  useAbsoluteCompetitorIndex: 'useAbsoluteCompetitorIndex',
  useMathematicalDelta: 'useMathematicalDelta',
  showUnsimulatedIndex: 'showUnsimulatedIndex',
  allowStoreGroupPriceLocking: 'allowStoreGroupPriceLocking',
  createWorkpackageFromCopy: 'createWorkpackageFromCopy',
  createWorkpackageReadsFromDatabricks: 'createWorkpackageReadsFromDatabricks',
  refreshWorkpackageFromDatabricks: 'refreshWorkpackageFromDatabricks',
  displayDistributionByAssortmentRole: 'displayDistributionByAssortmentRole',
  showAdditionalCostTypes: 'showAdditionalCostTypes',
  enableCompetitorSimulation: 'enableCompetitorSimulation',
  defaultCostChangeThresholdMin: 'defaultCostChangeThresholdMin',
  defaultCostChangeThresholdMax: 'defaultCostChangeThresholdMax',
  displayClientProductKey: 'displayClientProductKey',
  enableSimilarityGroups: 'enableSimilarityGroups',
  enableVolumeForecast: 'enableVolumeForecast',
  enablePriceOptimisation: 'enablePriceOptimisation',
  displayPriceOptimisationButtonOnlyForPriceList: 'displayPriceOptimisationButtonOnlyForPriceList',
  allowBulkPriceOverrides: 'allowBulkPriceOverrides',
  allowTransferToSameStoreFormat: 'allowTransferToSameStoreFormat',
  overrideSetExpiryDateEnabled: 'overrideSetExpiryDateEnabled',
  overrideSetExpiryDateDaysAfterGoLive: 'overrideSetExpiryDateDaysAfterGoLive',
  useNewWorkpackagesPage: 'useNewWorkpackagesPage',
  enableReferenceDate: 'enableReferenceDate',
  enableArchitectureLinePricingTabs: 'enableArchitectureLinePricingTabs',
  enableArchitectureV1: 'enableArchitectureV1',
  displayInYearImpact: 'displayInYearImpact',
  displayReporting: 'displayReporting',
  reportingMaxSelectableWorkpackages: 'reportingMaxSelectableWorkpackages',
  reportingMaxSelectableAttributes: 'reportingMaxSelectableAttributes',
  reportingMaxAttributeValues: 'reportingMaxAttributeValues',
  reportingWorkpackageLinkLevel: 'reportingWorkpackageLinkLevel',
  marginComparisonType: 'marginComparisonType',
  enableLinePricingGroupImport: 'enableLinePricingGroupImport',
  enableInputsOverridePage: 'enableInputsOverridePage',
  enablePricingImpactView: 'enablePricingImpactView',
  enableCompetitorPriceIgnore: 'enableCompetitorPriceIgnore',
  addCompetitorsMatchAttributes: 'addCompetitorsMatchAttributes',
  addCompetitorsMatchStatusAttributes: 'addCompetitorsMatchStatusAttributes',
  addVatChangeAttribute: 'addVatChangeAttribute',
  enableMarginInitialisation: 'enableMarginInitialisation',
  marginInitialisationSearchFunction: 'marginInitialisationSearchFunction',
  marginInitialisationRangeMin: 'marginInitialisationRangeMin',
  marginInitialisationRangeMax: 'marginInitialisationRangeMax',
  marginInitialisationSearchPrecision: 'marginInitialisationSearchPrecision',
  createWorkpackageWorkflow: 'createWorkpackageWorkflow',
  showToolAssignablePermissionsConfiguration: 'showToolAssignablePermissionsConfiguration',
  enableDatabricksDashboards: 'enableDatabricksDashboards',
  enableDashboardPricingBasketAnalysis: 'enableDashboardPricingBasketAnalysis',
  enableSkipOptimisation: 'enableSkipOptimisation',
  sparklineAnchorDay: 'sparklineAnchorDay',
  enableRecalculateAllKPIs: 'enableRecalculateAllKPIs',
  enableRefreshAlerts: 'enableRefreshAlerts',
  cancelScenarioPriceWithDoubleClick: 'cancelScenarioPriceWithDoubleClick',
  enableTSGLevelEngineRuns: 'enableTSGLevelEngineRuns',
  enableWorkpackagePeriodTypes: 'enableWorkpackagePeriodTypes',
  enableGridViewFillHandle: 'enableGridViewFillHandle',
  enableWorkpackageSettingsModal: 'enableWorkpackageSettingsModal',
  afterCreateWorkpackageUseBullQueue: 'afterCreateWorkpackageUseBullQueue',
  allowGhostProducts: 'allowGhostProducts',
  enableProductSwitchingService: 'enableProductSwitchingService',
};
